import { render, staticRenderFns } from "./EditarFoto.vue?vue&type=template&id=0d2801c9&"
import script from "./EditarFoto.vue?vue&type=script&lang=js&"
export * from "./EditarFoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports